export enum ApplePaylaterFlowType {
  Ecomm = 'Ecomm',
  WalletProvisioning = 'wallet-provisioning',
  InStore = 'in-store',
}
